module.exports = __webpack_public_path__ + "img/ezgif.com-apng-maker-4.ae53dbb2.png";